import React from 'react';

export interface FacebookColorIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const FacebookColorIcon: React.FC<FacebookColorIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M15.999 4c6.627 0 11.999 5.372 11.999 11.999s-5.372 11.999-11.999 11.999S4 22.628 4 15.999 9.372 4 15.999 4" clip-rule="evenodd"/><path fill="currentColor" d="M17.56 27.9v-9.27h2.613l.345-3.263H17.56l.004-1.634c0-.85.081-1.307 1.304-1.307H20.5V9.163h-2.613c-3.14 0-4.244 1.582-4.244 4.245v1.959h-1.958v3.263h1.958v9.137a12 12 0 0 0 3.916.132"/></g><defs><linearGradient id="b" x1="-6.983" x2="-6.983" y1="-20.109" y2="5.351" gradientUnits="userSpaceOnUse"><stop stop-color="#00b2ff"/><stop offset="1" stop-color="#006aff"/></linearGradient><filter id="a" width="32.499" height="32" x="-.501" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_194_205106"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_194_205106" mode="multiply" result="effect2_dropShadow_194_205106"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_194_205106" result="shape"/></filter></defs>
    </svg>
  );
};

export default FacebookColorIcon;
